import styled, { css, DefaultTheme } from "styled-components";

type TextProps = {
  color?: string;
};

export const H1 = styled.h1(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 38,
    fontWeight: 600,
    lineHeight: "54px",
    color: theme.colors.black,
  }))
);

export const Metric = styled.h1(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 38,
    fontWeight: 700,
    lineHeight: "54px",
    color: theme.colors.black,
  }))
);

export const H2 = styled.h2(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 26,
    fontWeight: 600,
    lineHeight: "36px",
    color: theme.colors.black,
  }))
);
export const H3 = styled.h3(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 20,
    fontWeight: 500,
    lineHeight: "28px",
    color: theme.colors.black,
  }))
);

export const H4 = styled.h4(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 16,
    fontWeight: 500,
    lineHeight: "24px",
    color: theme.colors.black,
  }))
);

export const Subtitle1 = styled.h4(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    color: theme.colors.black,
  }))
);

export const Subtitle2 = styled.h4(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 11,
    fontWeight: 600,
    lineHeight: "16px",
    color: theme.colors.black60,
  }))
);

export const P = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 15,
    fontWeight: 400,
    lineHeight: "22px",
    color: theme.colors.black80,
  }))
);

export const P2 = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 12,
    fontWeight: 400,
    lineHeight: "18px",
    color: theme.colors.black40,
  }))
);

type CaptionProps = {
  hasError?: boolean;
  theme: DefaultTheme;
} & React.BaseHTMLAttributes<HTMLParagraphElement>;
export const Caption = styled.p<CaptionProps>(
  ({ theme: { colors }, hasError }) => css`
    font-size: 10px;
    font-weight: 400;
    line-height: 15px;
    color: ${colors.black60};
    ${hasError &&
    css`
      color: ${colors.error};
    `}
  `
);

export const UserText = styled.p(
  ({ theme }) => theme.fonts.arial,
  css(({ theme }) => ({
    fontSize: 16,
    fontWeight: 400,
    lineHeight: "20px",
    color: theme.colors.black80,
  }))
);

export const Selected = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 15,
    fontWeight: 600,
    lineHeight: "22px",
    color: theme.colors.black80,
  }))
);

export const LinkText = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    color: theme.colors.black80,
  }))
);

export const Li = styled.p<TextProps>(
  ({ theme: { colors }, color }) => css`
    font-size: 15px;
    font-weight: 500;
    line-height: 21px;
    color: ${colors.black80};
    ${color &&
    css`
      color: ${color};
    `}
  `
);

export const Body1 = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 15,
    fontWeight: "normal",
    lineHeight: "21px",
    color: theme.colors.black80,
  }))
);

export const Body2 = styled.p`
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  line-height: 17px;
  color: ${(p) => p.theme.colors.black80};
`;

export const Td = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.colors.black80,
  }))
);

type LabelProps = {
  isDisabled?: boolean;
};
export const Label = styled.label<LabelProps>(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    display: "block",
    fontSize: 14,
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.colors.black70,
    marginBottom: "20px",
  })),
  ({ isDisabled }) =>
    css`
      ${isDisabled &&
      css`
        color: ${(props) => props.theme.colors.black40};
      `}
    `
);

export const Error = styled.p(
  ({ theme }) => theme.fonts.poppins,
  css(({ theme }) => ({
    fontSize: 12,
    fontWeight: 500,
    lineHeight: "18px",
    color: theme.colors.error,
  }))
);
